import { Chantier } from '../../models/chantier'
import { ChantierDto } from '../../data-access/dto/chantier.dto'

export class ChantierMapper {
  static dtoToModel(chantierDto: ChantierDto): Chantier  {
    if (!chantierDto) {
      return null;
    }
    return {
      code: chantierDto.code,
      nom: chantierDto.nom,
      displayName: chantierDto.code + ' - ' + chantierDto.nom,
    }
  }

  static dtosToModels(chantierDtos: ChantierDto[]): Chantier[]  {
    if (!chantierDtos || !chantierDtos.length) {
      return [];
    }
    return chantierDtos.map(ChantierMapper.dtoToModel)
  }
}
